require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./2016-년-5-월-tiobe-순위.json") })
        }
      }, "path---2016-년-5-월-tiobe-순위");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---2016-년-5-월-tiobe-순위!./.cache/json/2016-년-5-월-tiobe-순위.json
// module id = 423
// module chunks = 231608221292675